// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__12wCi","background":"styles_background__2UpzG"};